export const APP_STATES = {
  LOADING: 'loading',
  PWA_INSTALL: 'pwa_install',
  PWA_INSTALL_FROM_PROFILE: 'pwa_install_from_profile',
  LOGIN: 'login',
  MAIN: 'main'
};
